import { connect } from 'react-redux';
import has from 'lodash/has';
import {
  fetchResourceMetricsAggregate,
  fetchResourceMetricsPerDay,
  loadDataSource,
  loadFullVendor,
} from '../../../actions';

import { getConnectionOrVendorType, isSqlAutomation } from '../../../lib/ResourceUtils';

import { isReadOnly } from '../../../lib/ACLUtils';

import { getMetricsForSource, getCurrentOrg } from '../../../reducers/selectors';
import DataSourceOverviewTab from './DataSourceOverviewTab';

const mapStateToProps = (state, ownProps) => {
  const { data } = ownProps;
  const {
    request,
    entities: { credentials, vendors, apiKeys, vendorEndpoints, vendorEndpointParams },
    sources: { summaryById },
    paging: { metaInfoById, sourceConfigById },
  } = state;

  const connectionOrVendorType = getConnectionOrVendorType(
    data,
    vendors,
    'source_type',
    'vendor_id',
  );
  const behaviorType = isSqlAutomation(data, vendors) ? 'sql_runner' : connectionOrVendorType;

  const connectionCategory =
    metaInfoById && has(metaInfoById, behaviorType)
      ? metaInfoById[behaviorType].connectionCategory
      : null;
  const resourceTypeFields = has(sourceConfigById, behaviorType)
    ? sourceConfigById[behaviorType]
    : [];

  const readOnly = isReadOnly(data);

  return {
    readOnly,
    vendors,
    vendorEndpoints,
    vendorEndpointParams,
    apiKeys: data?.api_keys?.map((id) => apiKeys[id]) || [],
    currentOrg: getCurrentOrg(state),
    credentials: data ? credentials[data.data_credentials] : null,
    metrics: getMetricsForSource(state, ownProps),
    connectionCategory,
    resourceTypeFields,
    summaryData: data && has(summaryById, data.id) ? summaryById[data.id] : null,
    isLoading: {
      aggMetrics: request.GET_RESOURCE_METRICS_AGGREGATE_REQUEST || false,
      dayMetrics: request.GET_RESOURCE_METRICS_BY_DAYS_REQUEST || false,
    },
  };
};
export default connect(mapStateToProps, {
  fetchResourceMetricsPerDay,
  fetchResourceMetricsAggregate,
  loadFullVendor,
  loadDataSource,
})(DataSourceOverviewTab);
